import styled from "@emotion/styled";
import { fontAngkor, fontFredoka } from "@product/scmp-sdk";

import { ArticleImageContainer } from "scmp-app/components/article/article-image/styles";
import { GenericPostiesLeading } from "scmp-app/components/article/article-leading/generic-posties-article-leading";
import { pageStyle } from "scmp-app/components/article/article-render/article-content/standard-styles";
import { GenericPostiesArticleVocabBox } from "scmp-app/components/article/article-vocab-box/generic-posties-article-vocab-box";
import { BaseLink } from "scmp-app/components/common/base-link";
import {
  H2Container as ContentSubHeadlineH2Container,
  H3Container as ContentSubHeadlineH3Container,
} from "scmp-app/components/content/content-sub-headline/styles";

import { PostiesSubHeadline } from "./sub-headline";

export const ListenNow = styled.div`
  margin-block-start: 64.5px;

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-start: 0;
  }
`;

export const Authors = styled.div`
  font-weight: 600;
`;

export const AuthorsAndPublishedDate = styled.div`
  order: 2;

  display: flex;
  flex-flow: column;
  justify-content: center;

  max-inline-size: 440px;
  margin-inline: auto;

  color: #555555;
  font-size: 18px;
  font-family: ${fontFredoka};
  line-height: 24px;
  text-align: center;
  column-gap: 8px;

  ${props => props.theme.breakpoints.up("desktop")} {
    max-inline-size: 100%;

    font-size: 20px;
    line-height: 28px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const Content = styled.div`
  ${props => pageStyle(props)}

  order: 5;

  inline-size: 100%;
  max-inline-size: 440px;
  margin-block-start: 40px;
  margin-inline: auto;

  color: #333333;
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontFredoka};
  line-height: 28px;
  letter-spacing: -0.01em;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-block-end: 16px;

    color: #ff7c1d;
  }

  strong {
    font-weight: 600;
  }

  a {
    color: #0f75bf;
  }

  ${ArticleImageContainer} {
    inset-inline-start: unset;
    inset-inline-end: unset;

    inline-size: 100%;
    margin-inline: auto;
  }

  img {
    border-radius: 12px;

    cursor: default !important;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 22px;
    line-height: 32px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    grid-column: 4 / span 6;

    max-inline-size: 100%;

    font-size: 24px;
    line-height: 36px;

    img {
      border-radius: 16px;
    }
  }
`;

export const GenericPostiesArticleContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-block-start: 56px;

  ${props => props.theme.breakpoints.up("desktop")} {
    display: grid;
    grid-template-columns: repeat(12, 1fr);

    margin-block-start: 96px;

    column-gap: 24px;

    .ima-ad-player {
      inline-size: 100% !important;
    }
  }
`;

export const Heading1 = styled.h1`
  /** add more specificity to override the pageStyle h1 */
  && {
    font-weight: 400;
    font-size: 48px;
    font-family: ${fontAngkor};
    line-height: 56px;
    letter-spacing: -0.03em;
  }
`;

export const Heading2 = styled.h2`
  /** add more specificity to override the pageStyle h2 */
  && {
    font-weight: 400;
    font-size: 32px;
    font-family: ${fontAngkor};
    line-height: 38px;
    letter-spacing: -0.03em;
  }
`;

export const Heading3 = styled.h3`
  /** add more specificity to override the pageStyle h3 */
  && {
    font-weight: 400;
    font-size: 28px;
    font-family: ${fontAngkor};
    line-height: 36px;
    letter-spacing: -0.01em;
  }
`;

export const Heading4 = styled.h4`
  /** add more specificity to override the pageStyle h4 */
  && {
    font-weight: 600;
    font-size: 24px;
    font-family: ${fontFredoka};
    line-height: 36px;
    letter-spacing: -0.01em;
  }
`;

export const Heading5 = styled.h5`
  /** add more specificity to override the pageStyle h5 */
  && {
    font-weight: 400;
    font-size: 24px;
    font-family: ${fontFredoka};
    line-height: 32px;
    letter-spacing: 0;
  }
`;

export const Heading6 = styled.h6`
  /** add more specificity to override the pageStyle h6 */
  && {
    font-weight: 400;
    font-size: 24px;
    font-family: ${fontFredoka};
    line-height: 32px;
    letter-spacing: 0;
  }
`;

export const Headline = styled.div`
  max-inline-size: 440px;
  margin-inline: auto;

  color: #1b4191;
  font-weight: 400;
  font-size: 36px;
  font-family: ${fontAngkor};
  line-height: 40px;
  letter-spacing: -0.03em;
  text-align: center;

  ${props => props.theme.breakpoints.up("desktop")} {
    max-inline-size: 100%;

    font-size: 48px;
    line-height: 56px;
  }
`;

export const MobileTop = styled.div`
  order: 5;

  display: flex;
  flex-direction: column;
  align-items: center;

  margin-block-start: 32px;
  ${props => props.theme.breakpoints.up("desktop")} {
    display: none;
  }
`;

export const MobileBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-block-start: 20px;
  ${props => props.theme.breakpoints.up("desktop")} {
    display: none;
  }
`;

export const DesktopLeft = styled.div`
  grid-row: span 1;
  grid-column: span 4;

  position: sticky;

  display: none;

  margin-block-start: 56px;
  ${props => props.theme.breakpoints.up("desktop")} {
    grid-column: 1 / span 3;

    order: 5;

    display: block;
  }
`;

export const DesktopRight = styled.div`
  display: none;
  justify-self: end;

  margin-block-start: 56px;
  ${props => props.theme.breakpoints.up("desktop")} {
    grid-column: -4 / span 3;

    order: 5;

    display: block;
  }
`;

export const PublishedDate = styled.div`
  font-weight: 400;
`;

export const Right = styled.div`
  position: sticky;

  margin-block-start: 40px;

  ${props => props.theme.breakpoints.up("desktop")} {
    grid-column: -4 / span 3;

    margin-block-start: 56px;
  }
`;

export const Section = styled(BaseLink)`
  inline-size: fit-content;
  max-inline-size: 280px;
  margin-inline: auto;
  padding-block: 8px;
  padding-inline: 16px;

  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 24px;
  letter-spacing: 0.05em;
  text-align: center;
  text-transform: uppercase;

  border-radius: 8px;

  background: #ff7c1d;

  ${props => props.theme.breakpoints.up("desktop")} {
    max-inline-size: 100%;

    font-size: 18px;
  }
`;

export const StyledGenericPostiesArticleVocabBox = styled(GenericPostiesArticleVocabBox)`
  order: 6;
`;

export const StyledGenericPostiesLeading = styled(GenericPostiesLeading)`
  order: 3;

  ${props => props.theme.breakpoints.up("desktop")} {
    order: 4;
  }
`;

export const StyledPostiesSubHeadline = styled(PostiesSubHeadline)`
  order: 4;

  max-inline-size: 440px;
  margin-block: 30px 0;
  margin-inline: auto;

  ${props => props.theme.breakpoints.up("desktop")} {
    grid-column: 4 / span 6;

    order: 3;

    max-inline-size: 100%;
    margin-block: 44px 0;
  }

  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    margin-block: 50px 0;
  }

  ul,
  ol {
    padding-inline-start: 0;

    list-style-type: none;
  }

  p,
  li,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #333333;
    font-weight: 500;
    font-size: 20px;
    font-family: ${fontFredoka};
    line-height: 26px;

    ${props => props.theme.breakpoints.up("tablet")} {
      font-size: 22px;
      line-height: 28px;
    }

    ${props => props.theme.breakpoints.up("mediumDesktop")} {
      font-size: 24px;
      line-height: 32px;
    }
  }

  li {
    &::before {
      content: none !important;
    }
    &:not(:first-of-type) {
      display: none;
    }
  }

  ${ContentSubHeadlineH2Container}, ${ContentSubHeadlineH3Container} {
    > *:not(:first-child) {
      display: none;
    }
  }
`;

export const StyledTopBackgroundImage = styled.img`
  inline-size: 100%;

  object-fit: contain;
`;

export const TopBackgroundContainer = styled.div`
  position: absolute;
  inset-inline-start: -20px;
  z-index: -1;

  inline-size: 100vw;
  margin-block-start: -56px;

  ${props => props.theme.breakpoints.up("tablet")} {
    inset-inline-start: -40px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    inset-inline-start: -60px;

    margin-block-start: -96px;
  }

  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    inset-inline-start: -80px;
  }

  ${props => props.theme.breakpoints.up("xLargeDesktop")} {
    inset-inline-start: calc(-52px - 50vw + 780px);
  }
`;

export const TopBlock = styled.div`
  order: 1;

  display: flex;
  flex-direction: column;
  row-gap: 16px;
  justify-content: center;

  min-block-size: 300px;

  ${props => props.theme.breakpoints.up("desktop")} {
    grid-column: 4 / span 6;
  }
`;
